import type { GraphQLDiskCache as ServerGraphQLDiskCache } from './queryCache';

/**
 * `GraphQLDiskCache` da entrada "browser" do pacote: o cache é em disco
 * (`fs`, `path`, `crypto`) e só faz sentido no build. Existe para o import não
 * quebrar; instanciar no navegador lança. Ver TD-4 em docs/tech-debts.md.
 */
export class GraphQLDiskCache {
  constructor(..._args: ConstructorParameters<typeof ServerGraphQLDiskCache>) {
    throw new Error('[WpTools] GraphQLDiskCache só roda no servidor (build): o cache é em disco.');
  }
}
